<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12" style="text-align: center; margin-bottom: 12px;"><h6>{{ data.title }}</h6></div>
      <div class="col-md-6">
        <h6>Available Columns</h6>
        <draggable class="list-group" tag="ul" v-model="allUserPreferences" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
          <transition-group type="transition" :name="'flip-list'">
            <li class="list-group-item" v-for="element in allUserPreferences" :key="element.name">
              {{element.name}}
            </li>
          </transition-group>
        </draggable>
      </div>
      <div class="col-md-6">
        <div style="margin-bottom: 4px;">
          <h6 style="display: inline;">Selected Columns</h6> <span class="pull-right">Drag from the options on the left</span>
        </div>
        <draggable element="span" v-model="selectedUserPreferences" v-bind="dragOptions" :move="onMove">
          <transition-group name="no" class="list-group" tag="ul">
            <li class="list-group-item" style="padding: 0.41rem" v-for="element in selectedUserPreferences" :key="element.name">
              <div class="row">
                <div class="col-md-6" style="padding-top: 5px; margin: 0">
                  {{element.name}}
                </div>
                <div class="col-md-6">
                  <el-select name="state"
                             style="width: 150px; margin: 0"
                             class="select pull-right"
                             size="small"
                             clearable
                             placeholder="Sort Direction"
                             v-model="element.sortDirection">
                    <el-option class="select"
                               value="ascending"
                               label="Ascending"
                               key="ascending">
                    </el-option>
                    <el-option class="select"
                               value="descending"
                               label="Descending"
                               key="descending">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </li>
          </transition-group>
        </draggable>
      </div>
    </div>
    <div class="row" style="margin-top: 15px">
      <div class="col-md-12">
        <button type="submit" @click.prevent="save" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    notifySuccess,
    notifyError,
    userAdminAppPreferencesMergePatchPayload,
    assembleSortColumnsFromSelectedAdminAppPreferences,
    notSelectedAdminAppPreferences
  } from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import {sync} from 'vuex-pathify'
  import draggable from 'vuedraggable'
  import {OK} from 'http-status-codes'
  import _ from 'lodash'

  export default {
    props: ['data'],
    components: {
      draggable
    },
    data() {
      return {
        constants: Constants,
        allUserPreferences: [],
        selectedUserPreferences: [],
        editable: true,
        isDragging: false,
        delayedDragging: false
      }
    },
    computed: {
      user: sync('security@user'),
      secureUserSelectedPreferences() {
        return this.user.adminAppPreferences[this.data.preferenceType]
      },
      allSearchJobsAdminAppPreferences() {
        return this.$store.get('users/allUserPreferencesByType', this.data.preferenceType)
      },
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        }
      }
    },
    methods: {
      async save() {
        const sortColumns = assembleSortColumnsFromSelectedAdminAppPreferences(this.selectedUserPreferences)

        this.$store.commit('security/adminAppPreferences', {
          preferenceType: this.data.preferenceType,
          sortColumns
        })

        const payload = userAdminAppPreferencesMergePatchPayload(this.user)
        const response = await this.$store.dispatch('mergePatch2', payload)

        if (OK === response.status) {
          notifySuccess(this, 'User Preferences Updated Successfully')
          this.$emit('close')
          this.$eventHub.$emit('userPreferencesSaved')
          return
        }
        notifyError(this, 'Failed to Update User Preferences')
      },
      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element
        const draggedElement = draggedContext.element
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        )
      }
    },
    async beforeMount() {
      if (!this.$store.get('users/allUserPreferencesLoaded')) {
        await this.$store.dispatch('users/fetchAllPreferences')
      }
    },
    mounted() {
      this.selectedUserPreferences = _.cloneDeep(this.secureUserSelectedPreferences)
      this.allUserPreferences = notSelectedAdminAppPreferences(
        _.cloneDeep(this.allSearchJobsAdminAppPreferences),
        this.selectedUserPreferences
      )
    },
    watch: {
      selectedUserPreferences: {
        handler: function (selectedUserPreferences) {
          for (let i = 0; i < selectedUserPreferences.length; i++) {
            selectedUserPreferences[i].sortOrder = i + 1
          }
        }
      }
    }
  }
</script>
